import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import style from './edit-filterview-modal.module.less';
import { messages } from './messages';

export const ErrorMessage = ({ message }) => {
  return (
    <div className={style['error-wrapper']}>
      <div className={style.error}>
        <FontAwesomeIcon icon={faExclamationCircle} />
        <div className={style['error-message']}>
          <FormattedMessage {...messages.deleteViewErrorHeader} />
        </div>
      </div>
      <div className={style['error-details']}>{message}</div>
    </div>
  );
};

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};
